<app-environment-banner />
<main class="app-scroll">
  <router-outlet></router-outlet>
</main>
